export default __webpack_public_path__ + "static/media/hemant-dhonde.02a16917.png";